/**
 * Parsing helpers for user-entered numeric values in German/European formats.
 *
 * Examples accepted:
 *  - 1
 *  - "1"
 *  - "1,00"
 *  - "1.234,56"
 *  - "1 234,56"
 *  - "€ 1.234,56"
 *  - "1.234.567"
 */
export function parseDecimal(value: unknown): number | undefined {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value !== "string") return undefined;

  const trimmed = value.trim();
  if (trimmed === "") return undefined;

  // Remove currency symbols and spaces, keep digits, separators and minus
  const cleaned = trimmed.replaceAll(/[^\d,.-]/g, "");

  // If both '.' and ',' exist, assume grouping '.' and decimal ','
  // Else, treat ',' as decimal separator by replacing it with '.'
  const normalized =
    cleaned.includes(".") && cleaned.includes(",")
      ? cleaned.replaceAll(".", "").replace(",", ".")
      : cleaned.replaceAll(",", ".");

  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}
